
function encode(str: any): string {
  if (str === undefined || str === null) return '';
  str = str.toString();
  if (!str.match(/[\n"]/)) return str;
  return `"${str.replace(/"/g, '""')}"`;
}

export function generateCSV(data: any[]) {
  if (!data.length) return 'No data';
  const keys: string[] = [];
  for (const key in data[0]) keys.push(key);
  const rows = [keys.join(',')];
  for (const row of data) {
    rows.push(keys.map(key => encode(row[key])).join(','));
  }
  return rows.join('\n');
}

export default generateCSV;



// WEBPACK FOOTER //
// ./src/Logging/csv.ts